<template>
  <div class="cs-wrapper">
    <div class="cs-chat" v-if="open">
      <div class="cs-header">
        <span>在线客服</span>
        <span class="cs-close" @click="open = false">✕</span>
      </div>
      <div class="cs-body" ref="msgList">
        <div class="cs-msg" v-for="(m, i) in messages" :key="i" :class="{ user: m.fromRole === 'user' }">
          <div class="cs-bubble" v-html="m.message"></div>
          <div class="cs-time">{{ formatTime(m.createdAt) }}</div>
        </div>
        <div v-if="messages.length === 0" style="text-align:center;color:#ccc;padding:20px;">暂无消息</div>
      </div>
      <div class="cs-footer">
        <input type="text" v-model="input" placeholder="输入消息..." @keyup.enter="send">
        <button class="cs-send" @click="send">发送</button>
      </div>
    </div>
    <div class="cs-btn" @click="toggleOpen">
      <span class="cs-pulse-ring"></span>
      <span class="cs-icon">💬</span>
      <span class="cs-label">联系客服</span>
    </div>
  </div>
</template>

<script>
import { api } from '@/utils/api';
import { getSite } from '@/utils/theme';

function getUserId(site) {
  const key = 'chatUserId_' + site;
  let id = sessionStorage.getItem(key);
  if (!id) {
    const digits = String(Math.floor(Math.random() * 1000000)).padStart(6, '0');
    id = '客户' + digits;
    sessionStorage.setItem(key, id);
  }
  return id;
}

export default {
  name: 'CustomerService',
  data() {
    const site = getSite();
    return {
      site,
      open: false,
      input: '',
      messages: [],
      userId: getUserId(site),
      timer: null,
      initialLoaded: false
    };
  },
  methods: {
    async toggleOpen() {
      this.open = !this.open;
      if (this.open) {
        await this.fetchMessages();
        this.$nextTick(() => this.scrollBottom());
        if (!this.timer) {
          this.timer = setInterval(() => this.fetchMessages(), 5000);
        }
      }
    },
    async fetchMessages() {
      const data = await api.get('/api/chat/user/' + this.userId + '/messages?site=' + this.site);
      if (data.code === 200) {
        this.messages = data.data.messages || [];
      }
    },
    async send() {
      const msg = this.input.trim();
      if (!msg) return;
      this.input = '';
      await api.post('/api/chat/user/' + this.userId + '/send', { message: msg, site: this.site });
      await this.fetchMessages();
      this.$nextTick(() => this.scrollBottom());
    },
    formatTime(t) {
      if (!t) return '';
      const d = new Date(t);
      return String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
    },
    scrollBottom() {
      const el = this.$refs.msgList;
      if (el) el.scrollTop = el.scrollHeight;
    }
  },
  beforeUnmount() {
    clearInterval(this.timer);
  }
};
</script>

<style scoped>
.cs-wrapper {
  position: fixed;
  right: 16px;
  bottom: 80px;
  z-index: 9999;
}
.cs-btn {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  border-radius: 28px;
  background: linear-gradient(135deg, var(--color-primary-light), var(--color-primary));
  box-shadow: 0 4px 20px rgba(var(--color-primary-rgb), 0.5);
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  white-space: nowrap;
}
.cs-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 25px rgba(var(--color-primary-rgb), 0.6);
}
.cs-pulse-ring {
  position: absolute;
  inset: -6px;
  border-radius: 34px;
  border: 2px solid rgba(var(--color-primary-rgb), 0.5);
  animation: cs-pulse 2s ease-out infinite;
}
@keyframes cs-pulse {
  0% { transform: scale(1); opacity: 1; }
  100% { transform: scale(1.25); opacity: 0; }
}
.cs-icon {
  font-size: 22px;
}
.cs-label {
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1px;
}
.cs-chat {
  position: absolute;
  right: 0;
  bottom: 60px;
  width: 280px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.cs-header {
  background: linear-gradient(135deg, var(--color-primary-light), var(--color-primary));
  color: #fff;
  padding: 12px 16px;
  font-size: 15px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}
.cs-close {
  cursor: pointer;
  font-size: 16px;
  opacity: 0.8;
}
.cs-body {
  padding: 14px;
  height: 220px;
  overflow-y: auto;
  flex-shrink: 1;
}
.cs-msg {
  margin-bottom: 10px;
}
.cs-msg.user {
  text-align: right;
}
.cs-msg.user .cs-bubble {
  background: var(--color-primary);
  color: #fff;
}
.cs-bubble {
  background: #f0f0f0;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 14px;
  color: #333;
  line-height: 1.6;
  display: inline-block;
  max-width: 100%;
  word-break: break-word;
  text-align: left;
}
.cs-bubble a {
  color: var(--color-primary);
  font-weight: 600;
  text-decoration: none;
}
.cs-msg.user .cs-bubble a {
  color: #fff;
}
.cs-time {
  font-size: 10px;
  color: #ccc;
  margin-top: 2px;
}
.cs-footer {
  display: flex;
  border-top: 1px solid #eee;
  padding: 10px;
  gap: 8px;
  flex-shrink: 0;
}
.cs-footer input {
  flex: 1;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  padding: 8px 14px;
  font-size: 13px;
  outline: none;
  min-width: 0;
}
.cs-footer input:focus {
  border-color: var(--color-primary);
}
.cs-send {
  width: auto;
  padding: 8px 16px;
  background: var(--color-primary);
  color: #fff;
  border: none;
  border-radius: 20px;
  font-size: 13px;
  cursor: pointer;
  flex-shrink: 0;
  margin-top: 0;
}
</style>
